import {createContext, useContext} from "react";
import {CompaniesStore} from "../../features/GameField/Cards/companies.store";
import {PlayersStore} from "../../features/GameField/Players/model/players.store";
import {DealStore} from "../../features/GameField/Deal/dealStore";
import {AuctionStore} from "../../features/GameField/Actions/auction.store";
import {RegistrationStore} from "../../features/auth/registrationStore";
import {AdminStore} from "@pages//AdminPanel/adminStore";

class RootStore {
    // companiesStore: CompaniesStore;
    // playersStore: PlayersStore
    // dealsStore: DealStore
    // gameStore: GameStore
    // registrationStore: RegistrationStore
    // auctionStore: AuctionStore
    // adminStore: AdminStore

    constructor() {
        // this.companiesStore = new CompaniesStore(this)
        // this.playersStore = new PlayersStore(this)
        // this.dealsStore = new DealStore(this)
        // this.gameStore = new GameStore(this)
        // this.registrationStore = new RegistrationStore(this)
        // this.auctionStore = new AuctionStore(this)
        // this.adminStore = new AdminStore(this)
    }
}

export const rootStore = new RootStore();

export const StoreContext = createContext(rootStore);
export const StoreProvider = StoreContext.Provider;
export const useStore = () => useContext(StoreContext)
